import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Direction.module.css';

const Direction: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="direction" className={classes.direction}>
      <h2>{t('Directions.title')}</h2>
      <div className={classes.directionContainer}>
        <div className={classes.contactInfo}>
          <p>
            <strong>{t('Phone')}:</strong>{' '}
            <a href="tel:030 74685376">030 74685376</a>
          </p>
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:info@nana-thaimassage.com">info@nana-thaimassage.com</a>
          </p>
          <p>
            <strong>{t('Address')}:</strong> Dahlemer Weg 2, 14169 Berlin
          </p>
          <p>{t('Directions.directionDescription')}</p>
        </div>
        <div className={classes.mapWrapper}>
          {/* Einbettung des Google-Business-Eintrags, nicht nur der Adresse.
              Dadurch zeigt die Karte den Namen des Studios statt eines
              anonymen Punktes. */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d509.31392000954634!2d13.282107810544534!3d52.441319507729645!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a85a469b0775bd%3A0xcc068e59934b6453!2sNANA%20Traditionelle%20Thaimassage!5e1!3m2!1sde!2sus!4v1788416938236!5m2!1sde!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            title={t('Directions.title')}
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Direction;
